import useSWR from 'swr';
import api from "./base-url";
import { Application, LinkToShare } from "../../components/apps-components/apps-types";
import { User, Group } from "../../components/users/users-types";
import { DownloadAmount, LinkDownload, VersionForDownload } from '../../components/analytics/analytics-types';


const fetcher = (url: string) => api.get(url).then(res => res.data)

export function useApps () {
  const { data, error } = useSWR<Application[]>(`/apps`, fetcher)

  return {
    apps: data || [],
    isLoadingApps: !error && !data,
    isErrorApps: error
  }
}

export function useApp (id: number) {
  const { data, error } = useSWR<Application>(`/apps/${id}`, fetcher)

  return {
    app: data || {} as Application,
    versions: data?.versions || [],
    isLoadingApp: !error && !data,
    isErrorApp: error
  }
} 

export function useAppFiltered (name: string) {
  const { data, error } = useSWR<Application[]>(`/apps`, fetcher)

  return {
    appSearched: data?.filter(app => app.name === name)[0] || {} as Application,
    versions: data?.filter(app => app.name === name)[0].versions || [],
    isLoadingAppSearched: !error && !data,
    isErrorAppSearched: error
  }
} 

export function useLinks () {
    const { data, error } = useSWR<LinkToShare[]>(`/links`, fetcher)
  
    return {
      links: data?.map(link => ({...link, updated_at: link.createdAt})) || [],
      isLoadingLinks: !error && !data,
      isErrorLinks: error
    }
}

export function useLinksOneApp () {
    const { data, error } = useSWR<LinkToShare[]>(`/links?onlyActive=false`, fetcher )
  
    return {
      linksForOneApp: data || [],
      isLoadingLinksOneApp: !error && !data,
      isErrorLinksOneApp: error
    }
}

export function useLink (uuid: string, auth?: boolean) {
  const { data, error } = useSWR<LinkToShare>(auth ? `/links/auth/${uuid}` :  `/links/${uuid}`, fetcher )
  
    return {
      link: data || {} as LinkToShare,
      versionsLink: data?.versions || [],
      isLoadingLink: !error && !data,
      isErrorLink: error
    }
}

export function useDownloadApps () {
  const { data, error } = useSWR<VersionForDownload[]>(`/statistics/downloads/apps`, fetcher)

  return {
    downloadsPerApps: data || [],
    isLoadingDownloadsPerApps: !error && !data,
    isErrorDownloadsPerApps: error
  }
}

export function useDownloadLinks () {
  const { data, error } = useSWR<LinkDownload[]>(`/statistics/downloads/links`, fetcher)

  return {
    downloadsPerLinks: data || [],
    isLoadingDownloadsPerLinks: !error && !data,
    isErrorDownloadsPerLinks: error
  }
}

export function useDownloadApp (id: number) {
  const { data, error } = useSWR<DownloadAmount[]>(`/statistics/downloads/apps/${id}`, fetcher)

  return {
    downloadsPerApp: data || [],
    isLoadingDownloadsPerApp: !error && !data,
    isErrorDownloadsPerApp: error
  }
}

export function useDownloadLink (id: number) {
  const { data, error } = useSWR<LinkDownload[]>(`/statistics/downloads/links/${id}`, fetcher)

  return {
    downloadsPerLink: data || [],
    isLoadingDownloadsPerLink: !error && !data,
    isErrorDownloadsPerLink: error
  }
}

export function useGroups () {
  const { data, error } = useSWR<Group[]>(`/groups/me`, fetcher)

  return {
    groups: data || [],
    isLoadingGroups: !error && !data,
    isErrorGroups: error
  }
}

export function useAllGroups () {
  const { data, error } = useSWR<Group[]>(`/groups`, fetcher)

  return {
    allGroups: data || [],
    isLoadingAllGroups: !error && !data,
    isErrorAllGroups: error
  }
}

export function useGroup (id: number) {
  const { data, error } = useSWR<Group>(`/groups/${id}`, fetcher)

  return {
    group: data || {} as Group,
    isLoadingGroup: !error && !data,
    isErrorGroup: error
  }
}

export function useUsers () {
  const { data, error } = useSWR<User[]>(`/users`, fetcher)

  return {
    users: data || [],
    isLoadingUsers: !error && !data,
    isErrorUsers: error
  }
}

export function useUserInfo () {
  const { data, error } = useSWR<User>(`users/me`);

  return {
    user: data || {} as User,
    isLoadingUser: !error && !data,
    isErrorUser: error
  }
}

/* API returning the groups of a user */
export function useUserGroups (userId: string) {
  const { data, error } = useSWR<Group[]>(`users/${userId}/groups`);

  return {
    userGroups: data || [],
    isLoadingUserGroups: !error && !data,
    isErrorUserGroups: error
  }

}